import ApiConection from 'api_ref/ApiConection';
import { ConvertDateTimeToText, ConvertDateToText } from 'components/MyControl';
import Css from 'components/pages/application/login/Login.module.css';
import { useEffect, useState } from 'react';
import { Col, Form, Row, Button } from 'react-bootstrap';
import StorageUsage from './graph/StorageUsage';
import AccountUsage from './graph/AccountUsage';
import SystemUploadFileType from './graph/SystemUploadFileType';

export default function ProfileUseage({ data = undefined }) {
    
    const api = new ApiConection();
    const [Register, setRegister] = useState(data);
    const [currentUsed, setCurrentUsed] = useState({
        status: "",
        totalUserActive: undefined,
        totalFileSizeByte: undefined,
    });
    const [currentFile, setCurrentFile] = useState({
        status: "",
        totalFileCount: undefined,
        totalFileSizeByte: undefined,
        list_file_extension: [],
    });

    const [Config, setConfig] = useState({});

    const getCurrentUsed = async () => {
        if (Register.site_url == undefined) return;
        let data = {
            subDomain: Register.site_url,
        };
        const response = await api.getData(
            `api/ATS/CurrentUsed/${Register.register_number}`
        );
        if (response.status == "completed") {
            setCurrentUsed(response);
        }
    };
    const getCurrentFile = async () => {
        if (Register.site_url == undefined) return;
        let data = {
            subDomain: Register.site_url,
        };
        const response = await api.getData(
            `api/ATS/CurrentFile/${Register.register_number}`
        );
        if (response.status == "completed") {
            setCurrentFile(response);
        }
    };
    const getConfigApp = async () => {
        const response = await api.getData(`api/ConfigApp/53`);
        if (response.status === true) {
            setConfig(response);
        }
    };

    useEffect(() => {
        
        getConfigApp();
    }, []);
    useEffect(() => {
        getCurrentUsed();
        getCurrentFile();
    }, [Register]);
    return (
        Register !== undefined &&
        <div className='mt-3 mb-3'>
            <Row>
                <Col xl={4}>
                {Register.quontation != undefined && Config.data != undefined && (
                    <StorageUsage
                        total={Register.quontation.storage_volume}
                        used={currentUsed.totalFileSizeByte}
                        config={Config.data.value}
                    />
                )}
                </Col>
                <Col xl={4}>
                {Register.quontation != undefined && currentUsed != undefined && (
                    <AccountUsage
                        total={Register.quontation.user_volume}
                        used={currentUsed.totalUserActive}
                    />
                )}
                </Col>
                <Col xl={4}>
                    <SystemUploadFileType
                            listFileExtension={currentFile.list_file_extension}
                            total={Register.quontation.storage_volume}
                        />
                </Col>
            </Row>
           
               
        </div>
    )
}